import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayableItemListComponent } from '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component';
import { DigitalMarketingTemplatesViewModel } from '../digital-marketing-templates-view-model';

@Component({
  selector: 'app-digital-marketing-template-list',
  templateUrl:
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.html',
  styleUrls: [
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.scss',
    './digital-marketing-template-list.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DigitalMarketingTemplateListComponent extends DisplayableItemListComponent {
  constructor(
    digitalProductTemplatesViewModel: DigitalMarketingTemplatesViewModel // Provided by parent component
  ) {
    super(digitalProductTemplatesViewModel);
  }
}
